import { supabase } from "@/integrations/supabase/client";

/**
 * Fast sign-out.
 *
 * While signing out we raise a page-wide flag so the auth listeners
 * (AuthProvider, AuthInvalidator) ignore the SIGNED_OUT broadcast. Without it,
 * the live page reacts mid-sign-out (access check → paywall redirect → router
 * invalidation) and could freeze the tab before we ever reached /auth.
 * The network/local sign-out is capped at 1.5s, then we hard-navigate.
 */
export function isSigningOut() {
  return typeof window !== "undefined" && (window as any).__boardroomSigningOut === true;
}

export async function fastSignOut() {
  (window as any).__boardroomSigningOut = true;
  const timeout = new Promise((r) => setTimeout(r, 1500));
  try {
    await Promise.race([supabase.auth.signOut({ scope: "local" }), timeout]);
  } catch {
    /* ignore — we still clear locally below */
  }
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("sb-") && k.includes("-auth-token"))
      .forEach((k) => localStorage.removeItem(k));
  } catch {
    /* storage unavailable */
  }
  window.location.replace("/auth");
}
